import { objToQs } from "../Utils";

import Call from '../Call.v2';

const Sync = (serversType, param, port = '') => {
    return Call(`sync?${objToQs({ serversType, param, port })}`);
}

export default Sync;



// WEBPACK FOOTER //
// ./src/services/API/components/Sync.js